import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodeRepo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_110370_141)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.9231 0C5.09959 0 2.00002 3.09957 2.00002 6.92308V29.0769C2.00002 32.9004 5.09959 36 8.9231 36L29.3186 36C30.8845 36 32.1538 34.7307 32.1538 33.1649V23.5385C32.1538 23.4429 32.1441 23.3496 32.1257 23.2595C31.9965 22.6285 31.4382 22.1539 30.7692 22.1539L8.9231 22.1538C7.2962 22.1538 5.98397 22.5645 4.95313 23.2517C4.8905 23.2935 4.82922 23.336 4.76925 23.3794V6.92308C4.76925 4.62898 6.629 2.76923 8.9231 2.76923L27.9999 2.76925C28.7646 2.76925 29.3845 3.38916 29.3845 4.15386C29.3845 4.15386 29.3845 5.53848 30.7692 5.53848C32.1538 5.53848 32.1538 4.15386 32.1538 4.15386C32.1538 1.85976 30.2941 1.85966e-05 27.9999 1.85966e-05L8.9231 0ZM29.3845 24.9231L8.9231 24.9231C7.16078 24.9231 5.65479 26.0205 5.0513 27.5694C4.94701 27.8831 4.87966 28.1829 4.83694 28.4392C4.80179 28.6502 4.78473 28.823 4.77655 28.9376C4.77248 28.9947 4.77063 29.0366 4.76983 29.0609L4.76925 29.0827C4.77242 31.3741 6.63095 33.2308 8.9231 33.2308L29.3186 33.2308C29.355 33.2308 29.3845 33.2013 29.3845 33.1649V24.9231ZM30.0011 8.54026C30.6373 8.11607 31.497 8.28801 31.9213 8.92427L34.6806 13.0632C34.8192 13.265 34.9057 13.5054 34.9206 13.765C34.9222 13.792 34.923 13.8192 34.923 13.8462C34.923 13.8636 34.9227 13.8811 34.922 13.8985C34.9119 14.1692 34.8241 14.42 34.6804 14.6293L31.9213 18.7681C31.497 19.4043 30.6373 19.5763 30.0011 19.1522C29.3649 18.7279 29.1929 17.8682 29.6172 17.232L30.9512 15.2308H19.6922C18.9275 15.2308 18.3076 14.6109 18.3076 13.8462C18.3076 13.0814 18.9275 12.4616 19.6922 12.4616H30.9512L29.6172 10.4604C29.1929 9.82414 29.3649 8.96443 30.0011 8.54026Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_110370_141",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 36,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgCodeRepo);
export { ForwardRef as ReactComponent };
